export default __webpack_public_path__ + "1f3c5852ba00cb6fcd1d6260b6e1238a.png";